import { setFeatureSwitches } from "@src/utils/logClient";

export type FeatureFlagsResolution = "pending" | "fallback" | "fetched" | "failed";

type FeatureFlagContextUpdate = {
  featureFlags: Record<string, string>;
  featureFlagsLoaded: true;
  [key: string]: unknown;
};

export const publishFeatureFlagsToLoggingAndContext = async (
  featureFlags: Record<string, string>,
  updateContext: (update: FeatureFlagContextUpdate) => void,
  additionalContext: Record<string, unknown> = {},
) => {
  await setFeatureSwitches(featureFlags);
  updateContext({ ...additionalContext, featureFlags, featureFlagsLoaded: true });
};

export const publishFallbackFeatureFlagsToLoggingAndContext = async (
  featureFlags: Record<string, string>,
  updateContext: (update: FeatureFlagContextUpdate) => void,
  resolution: Extract<FeatureFlagsResolution, "fallback" | "failed">,
  additionalContext: Record<string, unknown> = {},
) => {
  try {
    await publishFeatureFlagsToLoggingAndContext(featureFlags, updateContext, {
      ...additionalContext,
      featureFlagsResolution: resolution,
    });
  } catch {
    updateContext({
      ...additionalContext,
      featureFlags,
      featureFlagsLoaded: true,
      featureFlagsResolution: "failed",
    });
  }
};
